/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmModelsGetClusterCurrency } from "../../funcs/llmModelsGetClusterCurrency.js";
import { formatResult, ToolDefinition } from "../tools.js";

export const tool$llmModelsGetClusterCurrency: ToolDefinition = {
  name: "llm-models-get-cluster-currency",
  description: `Get the cluster currency

Returns the single cluster-wide ISO-4217 currency code (null if not set).`,
  tool: async (client, ctx) => {
    const [result, apiCall] = await llmModelsGetClusterCurrency(
      client,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
